import NicuFilter from './NicuFilter';
import NicuDisplay from './NicuDisplay';
import { INicu } from '../types/interfaces/INicu';
import { useEffect, useState } from 'react';
import { SearchParms } from '../types/classes/SearchParms';
import { DisplayParms } from '../types/classes/DisplayParms';
import useNicus from '../hooks/useNicus';
import { INicusResponse } from '../types/interfaces/INicusResponse';
import { Box, CircularProgress, Grid } from '@mui/material';
import { Navigate  } from 'react-router-dom';
import { useErrorContext } from '../../global/hooks/useErrorContext';

//This functions creates nicu filter and nicu display.
export default function NicuFilterableList() {    
    const nicuResponse: INicusResponse = useNicus();
    const nicuList: Array<INicu> = nicuResponse.data == null ? [] : nicuResponse.data;
    const [loading, setLoading] = useState(nicuResponse.loading);
    const [nicuError, setNicuError] = useState(nicuResponse.error);
    const [searchParms, setSearchParms] = useState<SearchParms>(new SearchParms());
    const [displayParms, setDisplayParms] = useState<DisplayParms>(new DisplayParms());
    const { setError } = useErrorContext();

    useEffect(() => {
        if(!nicuResponse.loading) {
           setLoading(false);
        }
        if(nicuResponse.error) {
            setNicuError(true);
            setError({message: null, statusCode: 0});
        }
    }, [nicuResponse.loading, nicuResponse.error]);
      
    return (
        <>
            {nicuError && <Navigate to="/error" />}
            {!nicuError && <Box padding={3} sx={{flexGrow: 1}}>
                <Grid container spacing={{xs: 5, sm: 5, md: 30}} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={2}>
                        <NicuFilter nicus={nicuList} searchParms={searchParms} onSearchParmsChange={setSearchParms} onDisplayChange={setDisplayParms} /> 
                    </Grid>
                    <Grid item xs={10}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {loading && <CircularProgress />}
                        </Box>
                        <Box sx={{ flexGrow: 1 }}>
                            <NicuDisplay nicus={nicuList} searchParms={searchParms} displayParms={displayParms} onDisplayChange={setDisplayParms} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>}
        </>
    );
}